





















































































































































































import Side from '../components/side/index.vue'
import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import TheBrand from '@/center/components/blocks/header.vue'
import PlayBox from './play-box.vue'
import LearningCourseChapter from '@api/model/learning/LearningCourseChapter'
import LearningCourseWare from '@api/model/learning/LearningCourseWare'
import LearningMode from '@api/model/learning/LearningMode'
import LastLearningCourseWare from '@api/model/learning/LastLearningCourseWare'
import LearningMedia from '@api/model/learning/LearningMedia'
import LearningCourseModule from '@api/module/customer/learning/LearningCourseModule'
import playModule from '@/play/store/index'
import PlatformStatisticsModule from '@api/module/customer/platform/PlatformStatisticsModule'
import CurrentSchemeModule from '@/center/store/learningscheme/CurrentSchemeModule'
import SyllabusModule from '@api/module/customer/syllabus/SyllabusModule'
import IndustryRelationCustomerModule from '@api/module/customer/tag/industry/IndustryRelationCustomerModule'
import LearningSchemeModule from '@api/module/customer/myscheme/LearningSchemeModule'

interface IndexInfo {
  chapterIndex: number
  courseWareIndex: number
}

const convertImageUrl = (url: string) => {
  return url?.replace(/(\.\.?)\/mfs/g, '/mfs')
}

@Component({
  components: {
    TheBrand,
    Side,
    PlayBox
  }
})
export default class extends Vue {
  @Ref('playBox')
  playBox: any
  activeName = 'first'
  autoNext = false
  iHaveHadLearned = false
  isVideoPlay = true
  learningMedia = new LearningMedia()
  previewImageUrl = ''
  schemeId = '' // 接受路由传值 获取考纲树ID
  syllabusInfo = ''

  get learningCourse() {
    return LearningCourseModule.learningCourse
  }

  get learningCourseChapterList(): Array<LearningCourseChapter> {
    return LearningCourseModule.learningCourseChapterList
  }

  get learningMode(): LearningMode {
    return LearningCourseModule.learningMode
  }

  get lastLearningCourseWare(): LastLearningCourseWare {
    return LearningCourseModule.lastLearningCourseWare
  }

  get autoPlayNext(): boolean {
    return playModule.autoPlayNext
  }

  get currentPlayChapterIndex(): number {
    return playModule.currentPlayChapterIndex
  }

  get currentPlayCourseWareIndex(): number {
    return playModule.currentPlayCourseWareIndex
  }

  get teacherNames() {
    return this.learningCourse.teacherList.map(teacher => teacher.name).join('、')
  }

  get courseDesc() {
    return convertImageUrl(this.learningCourse.description)
  }

  get imageList() {
    return this.learningCourse?.description?.match(/<img(.*?)\/>/g)?.map(item => {
      return convertImageUrl(item.replace(/<(.*?)src="(.*?)"(.*?)\/>/g, '$2'))
    })
  }

  @Ref('imagePreviewer')
  imagePreviewer: any

  previewImage(event: any) {
    if (event.target.tagName === 'IMG') {
      this.previewImageUrl = event.target.getAttribute('src')
      this.imagePreviewer.showViewer = true
    }
  }

  @Watch('autoNext')
  autoNextWatch(val: boolean) {
    playModule.changeAutoPlayNext(val)
  }
  get currentUserScheme() {
    return CurrentSchemeModule.currentUserScheme
  }

  get getLearningCount() {
    return PlatformStatisticsModule.getStatisticsByCourseId(this.learningCourse.courseId)?.learningCount || 0
  }

  async back() {
    try {
      if (this.learningMode === LearningMode.Learning) {
        await this.$confirm('确定要离开学习页面吗？', '友情提示')
        await this.playBox.saveSchedule()
      }
      const backUrl = this.$route.query.backUrl as string
      if (backUrl) {
        window.location.replace(backUrl)
      }
    } catch (e) {
      console.log(e)
    }
  }

  toggleMediaType() {
    this.isVideoPlay = !this.isVideoPlay
  }

  async created() {
    this.autoNext = this.autoPlayNext
    try {
      // 初始化考纲
      // await syllabusModule.init()
      this.schemeId = this.$route.params.schemeId
      this.syllabusInfo = (await this.getIndustryMajorName()) || ''
      // 初始化学习数据
      await LearningCourseModule.init({ learningToken: this.$route.params.token })
      await this.playCourseWare()
      // 获取播放数
      await PlatformStatisticsModule.init({ courseId: this.learningCourse.courseId })
    } catch (e) {
      console.log(e)
      this.$message({
        message: '获取课程信息失败',
        type: 'error'
      })
    }
  }

  get hasNext() {
    const chapter = this.learningCourseChapterList[this.currentPlayChapterIndex]
    if (!chapter) {
      return this.currentPlayCourseWareIndex < LearningCourseModule.learningCourseWareList.length - 1
    }
    // 如果当前播放的课件id + 1大于当前章节的课件列表长度，则跳到下一个章节的第0个播放
    const courseWareList = LearningCourseModule.getLearningCourseWareListByChapterId(chapter.id)
    if (this.currentPlayCourseWareIndex + 1 >= courseWareList.length) {
      if (this.currentPlayChapterIndex + 1 >= this.learningCourseChapterList.length) {
        return false
      }
    }
    return true
  }

  get hasPrev() {
    if (this.currentPlayCourseWareIndex - 1 < 0) {
      if (this.currentPlayChapterIndex === 0) {
        return false
      }
      return false
    }
    return true
  }

  /**
   * 下一讲
   */
  next() {
    const chapter = this.learningCourseChapterList[this.currentPlayChapterIndex]
    let courseWareList: Array<LearningCourseWare> = new Array<LearningCourseWare>()
    if (!chapter) {
      courseWareList = LearningCourseModule.learningCourseWareList
    } else {
      // 如果当前播放的课件id + 1大于当前章节的课件列表长度，则跳到下一个章节的第0个播放
      courseWareList = LearningCourseModule.getLearningCourseWareListByChapterId(chapter.id)
    }
    if (this.currentPlayCourseWareIndex + 1 >= courseWareList.length) {
      // 如果当前播放的章节索引+1大于章节集合的长度，则提示没有下一章节，和课件
      if (this.currentPlayChapterIndex + 1 >= this.learningCourseChapterList.length) {
        return this.$message({ message: '没有下一个了', type: 'warning' })
      } else {
        const chapterIndex = this.currentPlayChapterIndex + 1
        const courseWareIndex = 0
        const newChapter = this.learningCourseChapterList[chapterIndex]
        // 如果当前播放的课件id + 1大于当前章节的课件列表长度，则跳到下一个章节的第0个播放
        const newCourseWareList = LearningCourseModule.getLearningCourseWareListByChapterId(newChapter.id)
        const newCourseWare = newCourseWareList[courseWareIndex]
        this.changeCourseWare({
          courseWare: newCourseWare,
          indexInfo: {
            chapterIndex: chapterIndex,
            courseWareIndex: courseWareIndex
          }
        })
      }
    } else {
      const courseWareIndex = this.currentPlayCourseWareIndex + 1
      const courseWare = courseWareList[courseWareIndex]
      this.changeCourseWare({
        courseWare: courseWare,
        indexInfo: {
          chapterIndex: this.currentPlayChapterIndex,
          courseWareIndex: courseWareIndex
        }
      })
    }
  }

  /**
   * 上一讲
   */
  pre() {
    const chapter = this.learningCourseChapterList[this.currentPlayChapterIndex]
    let courseWareList: Array<LearningCourseWare> = new Array<LearningCourseWare>()
    if (!chapter) {
      courseWareList = LearningCourseModule.learningCourseWareList
    } else {
      // 如果当前播放的课件id + 1大于当前章节的课件列表长度，则跳到下一个章节的第0个播放
      courseWareList = LearningCourseModule.getLearningCourseWareListByChapterId(chapter.id)
    }
    if (this.currentPlayCourseWareIndex - 1 < 0) {
      if (this.currentPlayChapterIndex === 0) {
        return this.$message({ message: '没有上一个了', type: 'warning' })
      } else {
        const newChapterIndex = this.currentPlayChapterIndex - 1
        const newChapter = this.learningCourseChapterList[newChapterIndex]
        // 如果当前播放的课件id + 1大于当前章节的课件列表长度，则跳到下一个章节的第0个播放
        const newCourseWareList = LearningCourseModule.getLearningCourseWareListByChapterId(newChapter.id)
        const courseWareIndex = newCourseWareList.length - 1
        const newCourseWare = newCourseWareList[courseWareIndex]
        this.changeCourseWare({
          courseWare: newCourseWare,
          indexInfo: {
            chapterIndex: newChapterIndex,
            courseWareIndex: courseWareIndex
          }
        })
      }
    } else {
      const courseWareIndex = this.currentPlayCourseWareIndex - 1
      const courseWare = courseWareList[courseWareIndex]
      this.changeCourseWare({
        courseWare,
        indexInfo: {
          chapterIndex: this.currentPlayChapterIndex,
          courseWareIndex: courseWareIndex
        }
      })
    }
  }

  get playMode() {
    return this.learningMode === LearningMode.Learning ? 'study' : 'listen'
  }

  async changeCourseWare(params: { courseWare: LearningCourseWare; indexInfo: IndexInfo }) {
    const lastLearningCourseWare = new LastLearningCourseWare()
    lastLearningCourseWare.coursewareId = params.courseWare.courseWareId
    lastLearningCourseWare.chapterId = params.courseWare.courseChapterId
    lastLearningCourseWare.courseId = this.learningCourse.courseId
    await this.playStaff(params.indexInfo, lastLearningCourseWare)
  }

  async playStaff(indexInfo: IndexInfo, playCourseWare: LastLearningCourseWare) {
    playModule.setIndexInfo(indexInfo)
    this.$router
      .replace({
        path: `/play/${this.playMode}/${this.$route.params.token}/${playCourseWare.coursewareId}`,
        query: this.$route.query
      })
      .catch((e: Error) => e)
    await this.startLearning(playCourseWare)
  }

  async startLearning(playCourseWare: LastLearningCourseWare) {
    try {
      await LearningCourseModule.doStartLearningWithEvent(playCourseWare)
    } catch (e) {
      if (!e.isSuccess()) {
        this.$message({
          message: e.errors[0]?.message?.replace(/[a-zA-Z]/g, ''),
          type: 'error'
        })
      }
    }
    this.learningMedia =
      LearningCourseModule.getCoursewareMediaResource(playCourseWare.coursewareId) || new LearningMedia()
  }

  async playCourseWare() {
    const info = this.getCurrentPlayCourseWare()
    await this.playStaff(info.indexInfo, info.playCourseWare)
  }

  end() {
    console.log(this.learningMedia.currentLearningSchedule)
    if (this.autoPlayNext) {
      this.next()
    }
  }

  getCurrentPlayCourseWare(): any {
    const indexInfo = {
      chapterIndex: 0,
      courseWareIndex: 0
    }
    let courseWare = new LearningCourseWare()
    if (!this.$route.params.courseWareId) {
      if (this.lastLearningCourseWare.coursewareId) {
        indexInfo.chapterIndex = this.learningCourseChapterList.findIndex(
          chapter => chapter.id === this.lastLearningCourseWare.chapterId
        )
        const courseWareList: Array<LearningCourseWare> = LearningCourseModule.getLearningCourseWareListByChapterId(
          this.lastLearningCourseWare.chapterId
        )
        indexInfo.courseWareIndex = courseWareList.findIndex(
          courseWare => courseWare.courseWareId === this.lastLearningCourseWare.coursewareId
        )
        courseWare.courseWareId = this.lastLearningCourseWare.coursewareId
        courseWare.courseChapterId = this.lastLearningCourseWare.chapterId
      } else {
        const getChapter = this.learningCourseChapterList[indexInfo.chapterIndex]
        if (!getChapter) {
          courseWare = LearningCourseModule.learningCourseWareList[indexInfo.courseWareIndex]
        } else {
          const courseWareList = LearningCourseModule.getLearningCourseWareListByChapterId(getChapter.id)
          courseWare = courseWareList[indexInfo.courseWareIndex]
        }
      }
    } else {
      courseWare =
        LearningCourseModule.getLearningCoursewareByCoursewareId(this.$route.params.courseWareId) ||
        new LearningCourseWare()
      if (!courseWare) {
        this.$message({ type: 'error', message: '播放失败' })
        return courseWare
      }
      indexInfo.chapterIndex = this.learningCourseChapterList.findIndex(
        chapter => chapter.id === courseWare.courseChapterId
      )
      const courseWareList: Array<LearningCourseWare> = LearningCourseModule.getLearningCourseWareListByChapterId(
        courseWare.courseChapterId
      )
      indexInfo.courseWareIndex = courseWareList.findIndex(cw => cw.courseWareId === courseWare.courseWareId)
    }

    const lastLearningCourseWare = new LastLearningCourseWare()
    lastLearningCourseWare.coursewareId = courseWare.courseWareId
    lastLearningCourseWare.chapterId = courseWare.courseChapterId
    lastLearningCourseWare.courseId = this.learningCourse.courseId
    return {
      playCourseWare: lastLearningCourseWare,
      indexInfo
    }
  }

  async getIndustryMajorName() {
    const syllabusId = LearningSchemeModule.getLearningSchemeBySchemeId(this.schemeId)?.syllabusId || ''
    if (syllabusId) {
      const res = await SyllabusModule.findSyllabusListPage({
        query: {
          syllabusIdList: [syllabusId]
        }
      })
      const majorId = res.data.currentPageData[0].major.id
      const majorName = res.data.currentPageData[0].major.name
      const industryName = IndustryRelationCustomerModule.IndustryAndMajor(majorId).name
      return `${industryName}/${majorName}`
    }
  }
}
